import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    align-items: flex-end;
    justify-content: flex-start;
    padding-inline: 25px;
    width: 100%;
`;

export const InputUnit = styled.span`
    color: #333;
    leading-trim: both;
    text-edge: cap;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 100%; /* 18px */
    max-width: 100px;
    text-align: right;
    @media (orientation: landscape) and (max-width: 1200px){
        font-size: 14px;
    }
`;

export const InputContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 5px;
    position: absolute;
    top: 75%;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`;

export const ContainerOperationMode = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    left: 15%;
    scale: 1.2;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`

export const ContainerState = styled.div`
    display: flex;
    flex-direction: row;
    position: absolute;
    top: 58%;
    left: 30%;
    scale: 1.2;
    pointer-events: ${(props) => (props.$Active === true ? 'auto' : 'none')};
`

export const ContainerImage = styled.div`
    display: flex;
    position: absolute;
    top: 25%;
`